import { stripStorefrontCodeFromUrl } from '~/lib/url/stripStorefrontCode'

export function useHeaderNavbarItems(): {
  links: ComputedRef<HeaderNavBarLink[] | undefined>
} {
  const storyblokStore = useStoryblokStore()

  const links = computed(() => {
    const links = storyblokStore.state.headerNavbar
    return links?.map(link => ({
      ...link,
      url: stripStorefrontCodeFromUrl(link.url).urlWithoutStorefrontCode,
    }))
  })

  return {
    links,
  }
}

export interface HeaderNavBarLink {
  url: string
  text: string
  color?: string | undefined
  hide?: boolean | undefined
  _uid: string
}
